import { colorYiq } from "@/projectRoot/src/utils/handlers/miscHandler";

interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
  fill?: boolean;
}

export const GridTwoColumn = ({
  width = 16,
  height = 16,
  hexColor = "#ffffff",
  fill = false
}: Props) => {

  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.266667" y="0.266667" width="6.4" height="15.4667" rx="1.86667" fill={hexColor} stroke={colorYiq(hexColor)} strokeWidth="0.533333"/>
      <rect x="9.33332" y="0.266667" width="6.4" height="15.4667" rx="1.86667" fill={hexColor} stroke={colorYiq(hexColor)} strokeWidth="0.533333"/>
    </svg>
  );
};

export default GridTwoColumn;
